module.exports = __webpack_public_path__ + "img/shipo-icon-double-arrow-up.6f528f0f.svg";